<div *ngIf="visibility" class="cand-modal yesno-modal">
    <article class="cand-modal__overlay cand-modal__overlay--small">
        <h1 class="cand-modal__title">
            {{ title | i18n }}
        </h1>
        <section class="cand-modal__content">
            <p class="cand-modal__message">
                {{ content | i18n }}
            </p>
            <footer class="recovery-form__footer">
                <button class="button button--primary" type="button" (click)="closeModal()">{{ closeButton | i18n }}</button>
            </footer>
        </section>
    </article>
    <div class="cand-modal__fade"></div>
</div>
